export const exitPercentDataPreview = {
  labels: ["Product Briefing", "Executive Briefing", "Business Choice", "Account Info"],
  datasets: [
    {
      data: [57.0, 15.0, 10.0, 5.0],
      backgroundColor: ["#FF6384", "#36A2EB", "#7eeb78", "#eb3f8b"]
    }
  ]
};

export const lexPlatformUsageDataPreview = {
  labels: ["Platform", "Mobile-Android", "Mobile-iOS"],
  datasets: [
    {
      data: [97.0, 85.0, 52.0],
      backgroundColor: ["#FF6384", "#36A2EB", "#7eeb78"]
    }
  ]
};

export const peakUsageTimeDataPreview = {
  labels: [
    "00-01",
    "01-02",
    "02-03",
    "03-04",
    "04-05",
    "05-06",
    "06-07",
    "07-08",
    "08-09",
    "09-10",
    "10-11",
    "11-12",
    "12-13",
    "13-14",
    "14-15",
    "15-16",
    "16-17",
    "17-18",
    "18-19",
    "19-20",
    "20-21",
    "21-22",
    "22-23",
    "23-24"
  ],
  datasets: [
    {
      label: "Hierarchy testing",
      data: [0, 0, 5, 7, 17, 7, 5, 4, 9, 12, 17, 11, 4, 4, 0, 12, 24, 27, 55, 77, 52, 12, 2, 0],
      backgroundColor: "#36A2EB",
      borderColor: "#FF6384"
    }
  ]
};

export const taskUsageDataPreview = {
  labels: [
    "Test Public Intent With Db",
    "ZOHO - Search Accounts",
    "ZOHO - Opportunities",
    "Executive Briefing",
    "Business Choice",
    "Account Info",
    "Products",
    "Product Status Quantity"
  ],
  datasets: [
    {
      label: "Alexa",
      data: [443, 212, 431, 256, 642, 654, 224, 123],
      backgroundColor: "#FF6384"
    },
    {
      label: "Browser",
      data: [443, 212, 754, 543, 135, 556, 123, 563],
      backgroundColor: "#36A2EB"
    }
  ]
};

export const uncompletedRequestsByIntentDataPreview = {
  labels: [
    "Account Info",
    "ZOHO - Search Accounts",
    "TestPublicIntentWithDb",
    "GetUserContact",
    "TakeANote",
    "LaunchRequest"
  ],
  datasets: [
    {
      label: "Browser",
      data: [43, 33, 15, 6, null, 2, null],
      backgroundColor: "#FF6384"
    },
    {
      label: "Mobile-Android",
      data: [14, 24, 7, 6, 1, 2, 7],
      backgroundColor: "#FF6384"
    },
    {
      label: "Alexa",
      data: [null, null, 5, null, 4, null, 1],
      backgroundColor: "#23b9ff"
    }
  ]
};

export const uncompletedRequestsByUserDataPreview = {
  labels: ["Jack Tuhtan", "Josip Bosnjakovic", "Boris Knezevic"],
  datasets: [
    {
      label: "Alexa",
      data: [8, 7, null],
      backgroundColor: "#FF6384"
    },
    {
      label: "Browser",
      data: [41, 15, 4],
      backgroundColor: "#23b9ff"
    },
    {
      label: "Mobile-Android",
      data: [4, 7, 15],
      backgroundColor: "#23b9ff"
    }
  ]
};

export const uncompletedRequestsInTotalDataPreview = {
  labels: ["Alexa", "Browser", "Mobile-iOS"],
  datasets: [{ data: [8, 78, 15], backgroundColor: ["#FF6384", "#36A2EB"] }]
};

export const uniqueUsersDataPreview = {
  labels: ["Alexa", "Browser", "Mobile-iOS"],
  datasets: [{ data: [5, 7, 11], backgroundColor: ["#FF6384", "#36A2EB"] }]
};

export const missedUtterancesDataPreview = {
  labels: ["Public Website"],
  datasets: [{ data: [54], backgroundColor: ["#FF6384"] }]
};

export const uniqueSessionsDataPreview = {
  labels: ["Alexa", "Browser", "Mobile-iOS"],
  datasets: [{ data: [45, 14, 7], backgroundColor: ["#FF6384", "#36A2EB"] }]
};

export const sessionsByUserDataPreview = {
  labels: ["Jack Tuhtan", "Josip Bosnjakovic", "Boris Knezevic", "Marin Kruzic", "Nea Dujmic"],
  datasets: [
    {
      label: "Alexa",
      data: [12, 17, 14, 14, 1],
      backgroundColor: "#FF6384"
    },
    {
      label: "Browser",
      data: [15, 6, 2, null, 10],
      backgroundColor: "#23b9ff"
    },
    {
      label: "Mobile-iOS",
      data: [14, 7, 4, 1, 7],
      backgroundColor: "#23b9ff"
    }
  ]
};

export const AVGNumberOfUtterancesPerSessionDataPreview = {
  labels: ["Jack Tuhtan", "Josip Bosnjakovic", "Boris Knezevic", "Marin Kruzic", "Nea Dujmic"],
  datasets: [
    {
      label: "Alexa",
      data: [12, 10, 8, 7, null],
      backgroundColor: "#FF6384"
    },
    {
      label: "Browser",
      data: [8, 3, 2, null, 3],
      backgroundColor: "#23b9ff"
    },
    {
      label: "Mobile-iOS",
      data: [8, 3, 2, null, 3],
      backgroundColor: "#23b9ff"
    }
  ]
};
